import { render, staticRenderFns } from "./TaskReview.vue?vue&type=template&id=751220c3&scoped=true"
import script from "./TaskReview.vue?vue&type=script&lang=js"
export * from "./TaskReview.vue?vue&type=script&lang=js"
import style0 from "./TaskReview.vue?vue&type=style&index=0&id=751220c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751220c3",
  null
  
)

export default component.exports